import { Buffer } from 'buffer';

export const encryptQueryParams = (object = {}) => {
  const buffer = Buffer.from(JSON.stringify(object), 'ascii');
  const encryptObject = buffer.toString('base64');
  return `query=${encryptObject}`;
};
